<template>
  <!-- eslint-disable -->
  <v-container fluid class="current-overview-map-vue shared-maps" id="current-overview-map-vue" style="padding: 0 !important;">
    <v-slide-y-transition mode="out-in">
      <div style="height: 100%; display: flex; position: relative;">
        <div id="map" class="map"></div>
        <div class="grid-container" id="grid-container" :style="{width: getGridWidth(), 'max-height': getTableHeightPercent(), 'height': !this.showMap ? '100%' : 'unset'}">  
          <div class="overview-tabs">
              <v-btn @click="exportDataToExcel()" :disabled="fetchingExcelDoc" small color="#FFF" style="float: right; position: relative; z-index: 1; margin: 10px;" :style="{'display': $vuetify.breakpoint.xs? 'none' : 'block'}">Export</v-btn>
              <v-tabs id="overview-tabs" v-model="currentTab" color="whitesmoke" style="background-color: whitesmoke" :touchless="true" slider-color="black" >
                <v-tab v-for="tab in gridTabs" :key="tab.key" ripple >{{tab.label}}</v-tab>
              </v-tabs>
              <v-btn @click="exportDataToExcel()" :disabled="fetchingExcelDoc" small color="#FFF" style="position: relative; z-index: 1; margin: 10px;" :style="{'display': $vuetify.breakpoint.xs? 'block' : 'none'}">Export</v-btn>
            <div>
              <v-layout id="filter-selectors" style="padding: 0 15px" wrap>
                <v-flex xs v-show="currentTab > 0" class="hide-dirty-input">
                  <v-select :items="LocationList" v-model="selectedLocations" multiple prepend-icon="filter_list" item-text="SelectText" item-value="Id" label="Filter by Location" single-line :append-icon="selectedLocations.length == 0 ? '' : 'clear'" @click:append="() => (selectedLocations = [])">
                    <template slot="selection" slot-scope="{ item, index }">
                      <div class="v-select__selections" v-if="index === 0 && selectedLocations.length == 1">
                        <span>{{item.SelectText}}</span>
                      </div>
                      <div class="v-select__selections" v-else-if="index === 0">
                        <span>{{selectedLocations.length}} Locations Selected</span>
                      </div>
                    </template>
                  </v-select>              
                </v-flex>
                <v-flex xs class="filter-options hide-dirty-input">
                  <v-select :items="transitStatus" v-model="selectedFilters" @blur="filter()" item-text="label" item-value="key" multiple prepend-icon="filter_list" label="Status Filters" single-line :append-icon="selectedFiltersFiltered.length == 0 ? '' : 'clear'" @click:append="() => {clearFilters();}">
                    <template slot="selection" slot-scope="{ item, index }">
                      <div class="v-select__selections" style="line-height: 32px;" v-if="index === 0 && selectedFiltersFiltered.length > 0">
                        <span>Status Filters Applied</span>
                      </div>
                      <div class="v-select__selections" v-if="index === 0 && selectedFiltersFiltered.length == 0 && selectedFilters.length > 0">
                        <span style="color: black;opacity: 0.53;line-height: 32px;">Status Filters</span>
                      </div>
                    </template>
                    <template v-slot:item="{ item }">
                        <div @click="filter(item.key)" class="filters-filter"></div>
                        <div @click="filterPriority(item.key)" class="filters-filterPriority"></div>
                        <v-checkbox style="pointer-events: none" v-model="item.active"></v-checkbox>
                        <v-icon :class="statusProperties[item.key].Class + '-icon'">label</v-icon>
                        <v-flex class="vert-center" style="width: 160px; color:black">&emsp;{{item.label}}</v-flex>
                        <a class="vert-center filter-icon"><v-icon >filter_list</v-icon></a>
                    </template>
                  </v-select>
                </v-flex>
                <v-flex xs>
                  <v-text-field label="Min Content Value" @keyup.enter="setMinimumPackageValue()" @blur="setMinimumPackageValue()" single-line v-model="minimumPackageValueText" prepend-icon="attach_money" :append-icon="minimumPackageValue == 0 ? '' : 'clear'" @click:append="() => {minimumPackageValueText = ''; setMinimumPackageValue();}"></v-text-field>       
                </v-flex>
                <v-flex xs>
                  <v-checkbox v-model="showRefrigeratedOnly" label="Refrigerated Only"></v-checkbox>
                </v-flex>
              </v-layout>
              <v-card flat>
                <div class="overview-data-table" id="overview-data-table">
                  <v-data-table :mobile-breakpoint="0" disable-pagination hide-default-footer hide-default-header :items="packageData" ref="packageDataTable" item-key="Id" :headers="getHeaders('filter')" :sort-by.sync="sortBy" :sort-desc.sync="descending" :loading="loading" >
                    <template v-slot:header="{ props: { headers } }">
                      <thead>
                        <tr>
                          <th v-for="(header) in headers" :key="header.value" :class="['column sortable', descending ? 'desc' : 'asc', header.value === sortBy ? 'active' : '']" @click="changeSort(header.value)"> 
                            {{header.text}} <v-icon small v-if="header.value === sortBy">{{descending ? "arrow_downward" : "arrow_upward"}}</v-icon><div v-if="header.subText">{{ header.subText }}</div> 
                            <div v-if="header.totalKey" >{{getHeaderTotal(header.totalKey)}}</div>
                          </th>
                        </tr>
                      </thead>
                    </template>
                    <template v-slot:item="{ item, expand, isExpanded }" item-key="HashKey" >
                      <tr oncontextmenu="return false;" @contextmenu="expand(!isExpanded); return false;" v-on:mouseenter="highlightCircle(item.Id, true)" v-on:mouseleave="highlightCircle(item.Id, false)" 
                        @click="clearPackageWeb(); zoomToLatLng(item.Lat, item.Lng)" @dblclick="locationRowDblclick(item); expand(true);" class="data-td no-text-select location-data-row" :class="{'highlighted-row': item.Selected, 'no-marker': item.Lat == 0 && item.Lng == 0}" 
                        :id="'overview-data-' + item.Id"
                        v-if="isSelectedLocation(item.LocationId) || currentTab === 0"
                      >
                        <td v-if="currentTab !== 0 && selectedLocations.length !== 1">
                          {{item.LocationName}}
                        </td>
                        <td class="no-text-select">
                          {{ item.City }}
                        </td>
                        <td class="no-text-select">
                          {{ item.State }}
                        </td>
                        <td class="total-packages-data">
                          {{item.Total}}
                        </td>
                        <td v-for="status in statusProperties" :key="status.Key" v-show="transitFilter[status.Key] === true">
                          <span v-if="item[status.Key] > 0" class="status-package-total">{{item[status.Key]}}</span><span v-else>-</span>
                        </td>
                        <td>
                          <span if="item.Value">${{item.Value.toLocaleString('USD')}}</span>
                        </td>
                        <td :class="{'has-refrigerated': item.Refrigerated > 0, 'no-refrigerated': item.Refrigerated == 0}">
                          {{item.Refrigerated}}
                        </td>
                      </tr>
                    </template>
                    <template v-slot:expanded-item="{ headers, item }">
                      <td :colspan="headers.length" style="padding: 0;">
                        <v-card flat>
                          <v-data-table :mobile-breakpoint="0" class="whitesmoke overview-sub-data-table" disable-pagination hide-default-footer ref="packageDetailDataTable" :items="item.PackageDetails" :sort-by.sync="subTableSortBy" :sort-desc.sync="subTableDescending" item-key="Id" :headers="subTableHeaders" >
                            <template v-slot:item="{ item }" item-key="HashKey" >
                              <tr v-on:mouseenter="highlightDetailMarker(item.TrackingNumber, true)" v-on:mouseleave="highlightDetailMarker(item.TrackingNumber, false)" v-if="(item.IsRefrigerated || !showRefrigeratedOnly) && item.ContentsValue >= minimumPackageValue && transitFilter[item.TransitStatus] === true">
                                <td><a target="_blank" :href="getTrackingUrl(item.TrackingNumber)">{{item.TrackingNumber}}</a></td>
                                <td>{{item.OrderNumber}}</td>
                                <td>{{item.TransitStatus}}</td>
                                <td>{{item.DestCity}}</td>
                                <td>{{item.DestState}}</td>
                                <td>{{item.Service}}</td>
                                <td><span v-if="item.IsRefrigerated">YES</span><span v-else>-</span></td>
                                <td class="package-content-value"><span>${{item.ContentsValue.toLocaleString('USD')}}</span></td>
                              </tr>
                            </template>
                          </v-data-table>
                        </v-card>
                      </td>
                    </template>
                  </v-data-table>
                </div>
              </v-card>
            </div>
          </div>
        </div>
        <div class="status-marker-legend" v-if="selectedLocationDetailWeb" :style="{'left': getCenterLeft()}">
          <v-layout>
            <div 
              v-for="status in statusProperties" :key="status.Key" 
              v-show="transitFilter[status.Key] == true && isPackageMarkerTotal(status.Key)"
              class="legend-marker" :class="status.Class" 
              v-on:mouseenter="highlightPackageDetailMarkerByKey(status.Key, true)" v-on:mouseleave="highlightPackageDetailMarkerByKey(status.Key, false)"
            >{{status.ShortLabel}}</div>
          </v-layout>
        </div>
        <div class="overview-toggles">
          <v-layout row style="flex-wrap: nowrap !important;">
            <v-flex xs6 style="margin-right: 15px">
              <v-switch label="Data" v-model="showGrid"></v-switch>
            </v-flex>
            <v-flex xs6 style="margin-right: 15px">
              <v-switch label="Map" :disabled="!showGrid" v-model="showMap"></v-switch>
            </v-flex>
          </v-layout>
        </div>
        <v-progress-circular class="progress-circle-loading" :size="55" :width="5" indeterminate color="primary" :style="{'left': getCenterLeft()}" v-if="loading" ></v-progress-circular>
        <v-progress-circular class="progress-circle-refreshing" :size="30" :width="5" indeterminate color="primary" v-if="refreshing" ></v-progress-circular>
        <v-btn text icon color="grey darken-1" style="position: absolute; right: 0;" @click="zoomToShowAllMarkers()">
          <v-icon dark>zoom_out_map</v-icon>
        </v-btn>
      </div>
    </v-slide-y-transition>
  </v-container>
<!-- eslint-enable -->
</template>

<script>
import allianceOverviewMapModule, {
  ALLIANCE_OVERVIEW_MAP_NAMESPACE
} from "./store/allianceOverviewMapStore";
// eslint-disable-next-line
import MapsMixin from "@/mixins/MapsMixin.js";
import { mapGetters } from "vuex";

export default {
  name: "CurrentOverviewMap",
  mixins: [MapsMixin],
  data() {
    return { selectedClients: [4] };
  },
  computed: {
    ...mapGetters(ALLIANCE_OVERVIEW_MAP_NAMESPACE, [
      "clientData",
      "originalData"
    ])
  },
  watch: {},
  mounted: /* istanbul ignore next */ function() {
    this.initOverviewMap();
  },
  created: /* istanbul ignore next */ function() {
    this.MAP_HELPER_MIXIN_NAMESPACE = ALLIANCE_OVERVIEW_MAP_NAMESPACE;
    this.$registerVuexModule(
      ALLIANCE_OVERVIEW_MAP_NAMESPACE,
      allianceOverviewMapModule
    );
    this.$isInRole([this.$roleDefs.ADMIN, this.$roleDefs.ALLIANCE]).then(
      res => {
        if (res) {
          this.loadClients();
          this.loadClientPackageData();
          this.initFilters();
          var self = this;
          var currentOverviewMapInterval = setInterval(function() {
            self.loadClientPackageData(true);
          }, this.currentOverviewMapIntervalRefreshTime);
          this.$store.intervals.currentOverviewMapInterval = currentOverviewMapInterval;
        } else this.$goHome();
      }
    );
  },
  methods: {}
};
</script>
